import { render } from "./EducSectionsListPage.vue?vue&type=template&id=55825d35&ts=true"
import script from "./EducSectionsListPage.vue?vue&type=script&lang=ts"
export * from "./EducSectionsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__